import {
  ImpersonationSessionCreateBody,
  impersonationApi
} from "@api/impersonationApi";
import { ImpersonationSessionWithToken } from "@wingspanhq/wingspan-api-sdk";
import { tokenStore } from "./tokenStore";

class ImpersonationService {
  /**
   * Creates an impersonation session and makes it the active token. The admin
   * session underneath is preserved, so `exit` is a complete way back.
   */
  async start(
    body: ImpersonationSessionCreateBody
  ): Promise<ImpersonationSessionWithToken> {
    const result = await impersonationApi.createImpersonationSession({
      impersonationSessionCreate: body
    });

    tokenStore.setImpersonation(result);

    return result;
  }

  /**
   * Returns to the admin session. The reload is what clears every cache the
   * impersonated identity populated — React Query, WSStore, module state —
   * which is far safer here than invalidating them by hand.
   */
  exit(): void {
    tokenStore.clearImpersonation();
    window.location.reload();
  }
}

export const impersonationService = new ImpersonationService();
